import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { UpsPickupConfig, UpsPickupScheduleDay } from '../_models/ups-pickup-config.interface';

// API-Zugriff für die UPS-Pickup-Planung (Büro-Seite „UPS-Abholung").
@Injectable({ providedIn: 'root' })
export class UpsPickupConfigService {
  private readonly basePath = environment.apiURL + 'ups_pickup_configs';
  private readonly http = inject(HttpClient);

  getConfigs(): Observable<UpsPickupConfig[]> {
    return this.http.get<UpsPickupConfig[]>(`${this.basePath}.json`, { withCredentials: true });
  }

  // Aufgelöste Regel pro Tag (inkl. Quelle + pickup_exists) für den Bereich
  // from..to ('YYYY-MM-DD', max. 100 Tage).
  getSchedule(from: string, to: string): Observable<UpsPickupScheduleDay[]> {
    return this.http.get<UpsPickupScheduleDay[]>(
      `${this.basePath}/schedule.json`, { params: { from, to }, withCredentials: true }
    );
  }

  create(config: Partial<UpsPickupConfig>): Observable<UpsPickupConfig> {
    return this.http.post<UpsPickupConfig>(
      `${this.basePath}.json`, { ups_pickup_config: config }, { withCredentials: true }
    );
  }

  update(id: number, config: Partial<UpsPickupConfig>): Observable<UpsPickupConfig> {
    return this.http.patch<UpsPickupConfig>(
      `${this.basePath}/${id}.json`, { ups_pickup_config: config }, { withCredentials: true }
    );
  }

  delete(id: number): Observable<{ id: number }> {
    return this.http.delete<{ id: number }>(`${this.basePath}/${id}.json`, { withCredentials: true });
  }
}
